export default {
	data() {
		return {
			activeTab: 'settings'
		}
	},
	methods: {
		activateTab(val, remember = true) {
			if (remember) {
				this.saveActiveTab(val)
			}
			this.activeTab = val
		},
		isActiveTab(val, remember = true) {
			if (remember) {
				let savedActiveTab = this.getActiveTab()
				if (savedActiveTab && savedActiveTab !== this.activeTab) {
					return val === savedActiveTab
				}
			}
			return val === this.activeTab
		},
		getActiveTabClass(val, remember = true, allowedValues = null, isDefault = false) {
			const isActive = this.isActiveTab(val, remember)
			if (!isActive && isDefault && allowedValues) {
				return !allowedValues.some(v => this.isActiveTab(v, remember)) ? 'r-tabs-state-active' : ''
			}
			return isActive ? 'r-tabs-state-active' : ''
		}

	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/tabs.js